// TODO: icon 枚举 loading,success, fail
export enum IconType {
  loading = 'loading',
  success = 'success',
  fail = 'fail'
}
